var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"has-website@1.0.0-98"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';
import { isProductionBuild } from './src/utils/isProductionBuild';

if (isProductionBuild()) {
	Sentry.init({
		dsn: 'https://c5a74fa96c75bb9e7ceba6cb17d8563e@o232156.ingest.us.sentry.io/4506949098209280',
		tracesSampleRate: 0.1,
		debug: false,
		environment: process.env.ENVIRONMENT,
	});
}
